import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { SubproductLevel_toTranslation_11D407F6, NormalizedSubproduct, SubproductLevel$reflection, NormalizedSubproduct$reflection } from "./Model.js";
import { bool_type, record_type, list_type, class_type, string_type, lambda_type, unit_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { SubproductDefinitionDTO$reflection } from "../SubproductDefinition/Model.js";
import { parseInt$, DateTimeExtensions_toDate, Result_toBool, optToStr, Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2, Flatpickr_OnChangeOption, SaveStatus, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { empty, tryFind, ofArray, singleton, tryHead, filter, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { Product, Product$reflection, ProductModule_fromString, ProductModule_ofInt, ProductModule_toString, ProductModule_toTranslation, ProductModule_toInt } from "../../DomainTypes.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { partialApply, uncurry, safeHash, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { InputType, lengthLTE, isNotNullOrWhitespace } from "../../Validation/Common.js";
import { DateOptionsSimple, DateOptionsSimple_get_getDefault, inputDateSimple, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DateModule_today, DateFormat_get_yyyy$002DMM$002Ddd, DateModule_toStr, DateModule_ofDateTime, DateModule_toDateTime } from "../../Svea.Dry/Time.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ButtonKind, wrappedButton, defaultProps, ButtonProps, ButtonProps_get_getDefault } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import "../../../src/Containers/Subproducts/View.scss";


class ModalType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreateSubproduct", "EditSubproduct"];
    }
}

function ModalType$reflection() {
    return union_type("Containers.Subproducts.View.ModalType", [], ModalType, () => [[["Item", NormalizedSubproduct$reflection()]], [["Item", NormalizedSubproduct$reflection()]]]);
}

class EditSubproductProps extends Record {
    constructor(ModalType, ReloadSubproducts, SaveSubproduct, CloseModalFn, SubproductDefinitions, Locale, SubproductLevel) {
        super();
        this.ModalType = ModalType;
        this.ReloadSubproducts = ReloadSubproducts;
        this.SaveSubproduct = SaveSubproduct;
        this.CloseModalFn = CloseModalFn;
        this.SubproductDefinitions = SubproductDefinitions;
        this.Locale = Locale;
        this.SubproductLevel = SubproductLevel;
    }
}

function EditSubproductProps$reflection() {
    return record_type("Containers.Subproducts.View.EditSubproductProps", [], EditSubproductProps, () => [["ModalType", ModalType$reflection()], ["ReloadSubproducts", lambda_type(unit_type, unit_type)], ["SaveSubproduct", lambda_type(NormalizedSubproduct$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["SubproductDefinitions", list_type(SubproductDefinitionDTO$reflection())], ["Locale", Locale$reflection()], ["SubproductLevel", SubproductLevel$reflection()]]);
}

const renderEditSubproductModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, inputRecord_1, LabelText_1, inputRecord_2, LabelText_2, inputRecord_3, LabelText_3, inputRecord_4, LabelText_4, arg_14, inputRecord_5, inputRecord_6, arg_16, arg_15;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    let subproduct_1;
    const matchValue = props.ModalType;
    let pattern_matching_result, subproduct;
    if (matchValue.tag === 1) {
        pattern_matching_result = 0;
        subproduct = matchValue.fields[0];
    }
    else {
        pattern_matching_result = 0;
        subproduct = matchValue.fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            subproduct_1 = subproduct;
            break;
        }
    }
    const productState = react.useState(subproduct_1.Product);
    const subproductDefinitionsOptions = map((definition_1) => [definition_1.Name, definition_1.Name], filter((definition) => (definition.ProductNr === ProductModule_toInt(productState[0])), props.SubproductDefinitions));
    const productSelectOptions = map((product) => [ProductModule_toTranslation(getTranslation, product), ProductModule_toString(product)], List_distinct(map((definition_2) => ProductModule_ofInt(definition_2.ProductNr), props.SubproductDefinitions), {
        Equals: equals,
        GetHashCode: safeHash,
    }));
    const saveStatusState = react.useState(new SaveStatus(0));
    let nameState;
    let arg;
    const matchValue_1 = subproduct_1.Name;
    arg = ((matchValue_1 === "") ? optToStr(map_1((tuple) => tuple[0], tryHead(subproductDefinitionsOptions))) : matchValue_1);
    nameState = react.useState(arg);
    const activeFromState = react.useState(subproduct_1.ActiveFrom);
    const activeToState = react.useState(subproduct_1.ActiveTo);
    const sortOrderState = react.useState(optToStr(subproduct_1.SortOrder));
    const inputFieldsAreValid = Result_toBool(Result_Bind((str_1) => isNotNullOrWhitespace(getTranslation, str_1), lengthLTE(getTranslation, 100, new InputType(2), nameState[0])));
    let bodyHtml;
    const children = [selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("Common.Name"), new SelectOption(new ValueProp(0, nameState[0], (e) => {
        const arg_4 = Browser_Types_Event__Event_get_Value(e);
        nameState[1](arg_4);
    }), "edit-subproduct-name", subproductDefinitionsOptions, inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps)))), selectOption((inputRecord_1 = SelectOption_get_getDefault(), (LabelText_1 = getTranslation("Common.Product"), new SelectOption(new ValueProp(0, ProductModule_toString(productState[0]), (e_1) => {
        const arg_5 = ProductModule_fromString(Browser_Types_Event__Event_get_Value(e_1));
        productState[1](arg_5);
        const arg_6 = optToStr(map_1((tuple_1) => tuple_1[0], tryHead(subproductDefinitionsOptions)));
        nameState[1](arg_6);
    }), "edit-subproduct-product", productSelectOptions, inputRecord_1.Classes, LabelText_1, inputRecord_1.Disabled, inputRecord_1.HTMLProps)))), inputDateSimple((inputRecord_2 = DateOptionsSimple_get_getDefault(), (LabelText_2 = getTranslation("Common.ActiveFrom"), new DateOptionsSimple("edit-subproduct-active-from", DateModule_toDateTime(activeFromState[0]), (arg_9) => {
        const arg_8 = DateModule_ofDateTime(arg_9);
        activeFromState[1](arg_8);
    }, (date) => DateTimeExtensions_toDate(props.Locale.ILocale, date), inputRecord_2.TimeTwentyFour, LabelText_2, true, inputRecord_2.Disabled, props.Locale, inputRecord_2.EnableBy, inputRecord_2.OnClearClick, inputRecord_2.ExtraFlatpickrOptions)))), inputDateSimple((inputRecord_3 = DateOptionsSimple_get_getDefault(), (LabelText_3 = getTranslation("Common.ActiveTo"), new DateOptionsSimple("edit-subproduct-active-to", map_1(DateModule_toDateTime, activeToState[0]), inputRecord_3.OnChange, (date_1) => DateTimeExtensions_toDate(props.Locale.ILocale, date_1), inputRecord_3.TimeTwentyFour, LabelText_3, true, inputRecord_3.Disabled, props.Locale, inputRecord_3.EnableBy, inputRecord_3.OnClearClick, singleton(Flatpickr_OnChangeOption((arg_11) => {
        const arg_10 = map_1(DateModule_ofDateTime, arg_11);
        activeToState[1](arg_10);
    })))))), render_1()((inputRecord_4 = TextProps$1_GetDefault(), (LabelText_4 = getTranslation("Contracts.ContractType.Subproducts.SortOrder"), new TextProps$1(sortOrderState[0], "number", inputRecord_4.Classes, (e_2) => {
        const arg_12 = Browser_Types_Event__Event_get_Value(e_2);
        sortOrderState[1](arg_12);
    }, inputRecord_4.Disabled, LabelText_4, "edit-subproduct-sort-order", inputRecord_4.ValidationFn, inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))))];
    bodyHtml = react.createElement("div", {
        className: "subproducts__edit-modal",
    }, ...children);
    const actionTranslationStr = (props.ModalType.tag === 0) ? getTranslation("Common.Create") : getTranslation("Common.Change");
    return renderAsModalThenSaveState(true, new ModalSize(1), (arg_14 = getTranslation("Contracts.ContractType.Subproducts.Subproduct"), toText(printf("%s %s"))(actionTranslationStr)(arg_14)), bodyHtml, (inputRecord_5 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("Common.Cancel"), inputRecord_5.Content, (_arg_5) => {
        props.CloseModalFn();
    }, inputRecord_5.Disabled, "edit-subproduct-modal-cancel-btn", inputRecord_5.SaveStatus, inputRecord_5.HTMLProps, inputRecord_5.ExtraClasses, inputRecord_5.Icon)), (inputRecord_6 = ButtonProps_get_getDefault(), new ButtonProps(actionTranslationStr, inputRecord_6.Content, (_arg_6) => {
        const subproduct_2 = new NormalizedSubproduct(subproduct_1.Id, nameState[0], productState[0], activeFromState[0], activeToState[0], parseInt$(sortOrderState[0]), props.SubproductLevel);
        saveStatusState[1](new SaveStatus(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.SaveSubproduct(subproduct_2), (_arg_1) => {
            const result = _arg_1;
            const arg_1 = (result.tag === 0) ? (new SaveStatus(2)) : (new SaveStatus(3, result.fields[0]));
            saveStatusState[1](arg_1);
            return singleton_1.Zero();
        })));
    }, !inputFieldsAreValid, "edit-subproduct-modal-accept-btn", inputRecord_6.SaveStatus, inputRecord_6.HTMLProps, inputRecord_6.ExtraClasses, inputRecord_6.Icon)), getTranslation("Common.Close"), (_arg_7) => {
        props.ReloadSubproducts();
        props.CloseModalFn();
    }, singleton([(arg_16 = getTranslation("Contracts.ContractType.Subproducts.Subproduct"), (arg_15 = getTranslation("Common.Saving"), toText(printf("%s %s"))(arg_15)(arg_16))), saveStatusState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderEditSubproductModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subproducts\\View.fs", 193);

export class SubproductsProps extends Record {
    constructor(LoadSubproducts, UpdateSubproduct, DeleteSubproduct, CreateSubproduct, LoadSubproductDefinitions, Locale, SubproductLevel, IsAdmin) {
        super();
        this.LoadSubproducts = LoadSubproducts;
        this.UpdateSubproduct = UpdateSubproduct;
        this.DeleteSubproduct = DeleteSubproduct;
        this.CreateSubproduct = CreateSubproduct;
        this.LoadSubproductDefinitions = LoadSubproductDefinitions;
        this.Locale = Locale;
        this.SubproductLevel = SubproductLevel;
        this.IsAdmin = IsAdmin;
    }
}

export function SubproductsProps$reflection() {
    return record_type("Containers.Subproducts.View.SubproductsProps", [], SubproductsProps, () => [["LoadSubproducts", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(NormalizedSubproduct$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(NormalizedSubproduct$reflection())]], [["ErrorValue", string_type]]])]))], ["UpdateSubproduct", lambda_type(string_type, lambda_type(Product$reflection(), lambda_type(class_type("System.DateOnly"), lambda_type(NormalizedSubproduct$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])])))))], ["DeleteSubproduct", lambda_type(string_type, lambda_type(Product$reflection(), lambda_type(class_type("System.DateOnly"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))], ["CreateSubproduct", lambda_type(NormalizedSubproduct$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["LoadSubproductDefinitions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(SubproductDefinitionDTO$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(SubproductDefinitionDTO$reflection())]], [["ErrorValue", string_type]]])]))], ["Locale", Locale$reflection()], ["SubproductLevel", SubproductLevel$reflection()], ["IsAdmin", bool_type]]);
}

export const renderSubproducts = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_3, subproduct_4, matchValue_5;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const subproductsLoadState = react.useState(new LoadState$2(0));
    const createOrEditSubproductModalState = react.useState(void 0);
    const deleteSubproductModalState = react.useState(void 0);
    const deleteSubproductSaveState = react.useState(new SaveStatus(0));
    const subproductDefinitionsLoadState = react.useState(new LoadState$2(0));
    const loadSubproducts = () => {
        subproductsLoadState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.LoadSubproducts(), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            subproductsLoadState[1](arg);
            return singleton_1.Zero();
        })));
    };
    react.useEffect(() => {
        loadSubproducts();
        subproductsLoadState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.LoadSubproductDefinitions(), (_arg_1) => {
            const result_1 = _arg_1;
            const arg_2 = (result_1.tag === 0) ? (new LoadState$2(2, result_1.fields[0])) : (new LoadState$2(3, result_1.fields[0]));
            subproductDefinitionsLoadState[1](arg_2);
            return singleton_1.Zero();
        })));
    }, []);
    const headers = ofArray([getTranslation("Common.Name"), getTranslation("Common.Product"), getTranslation("Common.ActiveFrom"), getTranslation("Common.ActiveTo"), getTranslation("Contracts.ContractType.Subproducts.SortOrder"), getTranslation("Common.Level")]);
    const findSubproduct = (rowId) => {
        const matchValue = subproductsLoadState[0];
        if (matchValue.tag === 2) {
            return tryFind((subproduct_1) => (subproduct_1.Id === rowId), matchValue.fields[0]);
        }
        else {
            return void 0;
        }
    };
    const dotMenu = props.IsAdmin ? ofArray([[getTranslation("Common.Edit") + " (Admin-only)", (arg_8) => {
        const arg_7 = map_1((arg_5) => (new ModalType(1, arg_5)), findSubproduct(arg_8));
        createOrEditSubproductModalState[1](arg_7);
    }], [getTranslation("Common.Remove") + " (Admin-only)", (arg_10) => {
        const arg_9 = findSubproduct(arg_10);
        deleteSubproductModalState[1](arg_9);
    }]]) : empty();
    let deleteSubproductModalHtml;
    const matchValue_2 = deleteSubproductModalState[0];
    if (matchValue_2 != null) {
        const subproduct_3 = matchValue_2;
        let header;
        const arg_12 = getTranslation("Contracts.ContractType.Subproducts.Subproduct");
        const arg_11 = getTranslation("Common.Remove");
        header = toText(printf("%s %s"))(arg_11)(arg_12);
        deleteSubproductModalHtml = renderAsModalThenSaveState(true, new ModalSize(0), header, (children_3 = [getTranslation("Common.AreYouSure")], react.createElement("div", {}, ...children_3)), new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_6) => {
            deleteSubproductModalState[1](void 0);
        }, defaultProps.Disabled, "delete-subproduct-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), new ButtonProps(getTranslation("Common.Remove"), defaultProps.Content, (_arg_7) => {
            const subproduct_2 = subproduct_3;
            deleteSubproductSaveState[1](new SaveStatus(1));
            startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.DeleteSubproduct(subproduct_2.Name, subproduct_2.Product, subproduct_2.ActiveFrom), (_arg_5) => {
                const result_2 = _arg_5;
                if (result_2.tag === 0) {
                    deleteSubproductSaveState[1](new SaveStatus(2));
                    loadSubproducts();
                    return singleton_1.Zero();
                }
                else {
                    deleteSubproductSaveState[1](new SaveStatus(3, result_2.fields[0]));
                    return singleton_1.Zero();
                }
            })));
        }, defaultProps.Disabled, "delete-subproduct-modal-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), getTranslation("Common.Close"), (_arg_8) => {
            deleteSubproductModalState[1](void 0);
        }, singleton([header, deleteSubproductSaveState[0]]));
    }
    else {
        deleteSubproductModalHtml = react.createElement(react.Fragment, {});
    }
    let subproductsTableHtml;
    const matchValue_3 = subproductsLoadState[0];
    switch (matchValue_3.tag) {
        case 1: {
            subproductsTableHtml = dotsLoading;
            break;
        }
        case 3: {
            subproductsTableHtml = error(matchValue_3.fields[0].split(""));
            break;
        }
        case 2: {
            subproductsTableHtml = renderDotMenuAreaTable(headers, map((subproduct) => {
                let format_1;
                const isDifferentLevel = !equals(subproduct.SubproductLevel, props.SubproductLevel);
                return [map((element) => {
                    if (isDifferentLevel) {
                        return react.createElement("span", {
                            className: "subproducts__greyed-out",
                        }, element);
                    }
                    else {
                        return element;
                    }
                }, ofArray([subproduct.Name, ProductModule_toTranslation(getTranslation, subproduct.Product), DateModule_toStr(DateFormat_get_yyyy$002DMM$002Ddd(), subproduct.ActiveFrom), optToStr(map_1((format_1 = DateFormat_get_yyyy$002DMM$002Ddd(), (d_1) => DateModule_toStr(format_1, d_1)), subproduct.ActiveTo)), optToStr(subproduct.SortOrder), SubproductLevel_toTranslation_11D407F6(getTranslation)(subproduct.SubproductLevel)])), isDifferentLevel ? (void 0) : subproduct.Id];
            }, matchValue_3.fields[0]), (_arg_9) => dotMenu, void 0, void 0, (value) => {
            });
            break;
        }
        default: {
            subproductsTableHtml = react.createElement(react.Fragment, {});
        }
    }
    let createOrEditSubproductModalHtml;
    const matchValue_4 = createOrEditSubproductModalState[0];
    if (matchValue_4 != null) {
        const modalType = matchValue_4;
        createOrEditSubproductModalHtml = renderEditSubproductModal(new EditSubproductProps(modalType, loadSubproducts, (modalType.tag === 0) ? props.CreateSubproduct : ((subproduct_4 = modalType.fields[0], partialApply(1, props.UpdateSubproduct, [subproduct_4.Name, subproduct_4.Product, subproduct_4.ActiveFrom]))), () => {
            createOrEditSubproductModalState[1](void 0);
        }, (matchValue_5 = (subproductDefinitionsLoadState[0]), (matchValue_5.tag === 2) ? matchValue_5.fields[0] : empty()), props.Locale, props.SubproductLevel));
    }
    else {
        createOrEditSubproductModalHtml = react.createElement(react.Fragment, {});
    }
    const children_10 = [props.IsAdmin ? wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateNew"), defaultProps.Content, (_arg_10) => {
        const arg_15 = new ModalType(0, new NormalizedSubproduct("", "", new Product(0), DateModule_today(), void 0, void 0, props.SubproductLevel));
        createOrEditSubproductModalState[1](arg_15);
    }, defaultProps.Disabled, "subproducts-create-new-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : react.createElement(react.Fragment, {}), react.createElement("div", {
        className: "fit-content",
    }, subproductsTableHtml), createOrEditSubproductModalHtml, deleteSubproductModalHtml];
    return react.createElement("div", {
        className: "subproducts",
    }, ...children_10);
}, void 0, uncurry(2, void 0), void 0, "renderSubproducts", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subproducts\\View.fs", 410);

